import { useState, useEffect } from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Box,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import AuthorizationComponent from "../AuthorizationComponent/AuthorizationComponent";
import SignatureViewer from "../../../../../../components/composed-styled-components/SignatureViewer/SignatureViewer";
import CollectionsBreakdown from "./components/CollectionsBreakdown/CollectionsBreackdown";
import LotClosureTaker from "./components/LotClousureTaker/LotClousureTaker";
import MessageDialog from "../../../../../../components/composed-styled-components/MessageDialog/MessageDialog";
import { useAuth } from "../../../../../../context/AuthContext/AuthContext";
import { useAdministrationPanel } from "../../../../AdministrationContext/AdministrationPanelContext";
import useAxios from "../../../../../../context/AxiosContext/AxiosContext";
import {
  TaxPaymentcalculationsAdvisor,
  ClosingDay,
  ClosingDayByIdUser,
} from "../../../../../../configurations/Axios/urls";
import { isProduction } from "../../../../../../configurations/Axios/Clients";
import { getCurrentDateTime } from "../../../../../../configurations/Helpers/Dateshelper";
import { base64ToBlob } from "../../../../../../configurations/Helpers/Fileshelper";
import { useFirebase } from "../../../../../../context/FirebaseContext/FirebaseContext";
import { useNavigate } from "react-router-dom";
import CommentsHistoryAccordion from "./components/CommentsHistoryAccordion/CommentsHistoryAccordion";
import ImagesHistoryAccordion from "./components/ImagesHistoryAccordion/ImagesHistoryAccordion";
import { v4 as uuidv4 } from "uuid";

const DayClousure = ({ authorization }: any) => {
  const { user, logout } = useAuth();
  const [PrevDayClousure, setPrevDayClousure] = useState<any>();
  const { urlsfiltered } = useAdministrationPanel();
  const { VisitaxGet, VisitaxPost, VisitaxPut } = useAxios();
  const navigate = useNavigate();
  const [comments, setComments] = useState("Sin observaciones");
  const [vouchersComplete, setVouchersComplete] = useState(false);
  const [vouchersUploaded, setVouchersUploaded] = useState(false);
  const [openAuth, setOpenAuth] = useState(false);
  const [valueseted, setValueSetd] = useState(0);
  //const [lotClousure, setLotClousure] = useState(null);
  const [imagesTaken, setImagesTaken] = useState<string[]>([]);
  //const [lotClosureUrls, setLotClosureUrls] = useState<string>("");
  const [differenceModalOpen, setDifferenceModalOpen] = useState(false);
  const [Calculationadvisor, setCalculationadvisor] = useState<any>(null);
  const [Difference, setDifference] = useState<{
    status: boolean;
    diferenceamount: number;
    valueseted: number;
  }>({ status: false, diferenceamount: 0, valueseted: 0 });
  const [supervisorLogoutDialogOpen, setSupervisorLogoutDialogOpen] =
    useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    message: "",
    type: "success",
    open: false,
  });
  const [userSignature, setuserSignature] = useState({
    signature: "",
    name: "",
  });

  const CalculationadvisorTitles = {
    totalTransaccions: "Total en sistema",
    sumaQR: "Total de QRs",
    cobrosTPV: "Cobros con TPV",
    cobrosMultiPagos: "Cobros con Order-Point",
    cobrosOpenPay: "Cobros con OpenPay",
    toTalCobros: "Suma de cobros",
    cancelaciones: "Cancelaciones",
    sumatotalcacelada: "Cancelaciones + Cobros",
  };
  const [isClosingday, setisClosingday] = useState(false);

  const { firebasestorage } = useFirebase();

  useEffect(() => {
    const { name, lastName, fatherLastName, motherLastName } = user || {};
    const fullname = `${name || ""} ${lastName || ""} ${fatherLastName || ""} ${
      motherLastName || ""
    }`;
    setSignature("", fullname.trim());

    VisitaxGet(ClosingDayByIdUser + "?idUser=" + user?.id, (response: any) => {
      if (response.status == 200) {
        if (!response.data.data) {
          console.log("No se encontro cierre de dia");
          return;
        }
        const ClousureDay = response.data.data;
        setPrevDayClousure({
          ...ClousureDay,
          calculationHistory: JSON.parse(ClousureDay.calculationHistory),
        });
        return;
      }
      console.log("No se encontro cierre de dia");
    });
  }, [user]);

  const setSignature = (signature: any, fullname: any) =>
    setuserSignature({ signature, name: fullname });

  const handleDayClosure = () => setOpenAuth(true);
  const handleAuthorize = (auth: any) => {
    if (auth.state) {
      setSignature(auth.user.signature, userSignature.name);
      setOpenAuth(false);
    }
  };

  const getCalcullationAdvisor = () => {
    const complementaryurl = urlsfiltered.onlydates + "&iduser=" + user?.id;
    const onResponse = (response: any) => {
      if (response.status == 200) {
        setCalculationadvisor(response.data.data);
        return;
      }
    };
    VisitaxGet(TaxPaymentcalculationsAdvisor + complementaryurl, onResponse);
  };

  const showMessage = (message: string, severity = "success") => {
    setDialogData({
      title:
        severity === "success"
          ? "Cierre de dia creado exitosamente"
          : severity === "warning"
          ? "Datoso incompletos"
          : "Error al crear el cierre de dia",
      message: message,
      type: severity,
      open: true,
    });
  };

  const Validations = () => {
    if (!Calculationadvisor) return false;

    const {
      cobrosOpenPay = 0,
      cobrosTPV = 0,
      cobrosMultiPagos = 0,
    } = Calculationadvisor;

    // 🟩 Caso permitido sin foto: SOLO OpenPay
    const onlyOpenPay =
      cobrosOpenPay > 0 &&
      cobrosTPV === 0 &&
      cobrosMultiPagos === 0

    // 🟥 Si NO es solo OpenPay → se requiere imagen
    const imageRequired = !onlyOpenPay;

    // 🛑 Validación de imágenes
    if (imageRequired && imagesTaken.length === 0) {
      showMessage(
        "Debe subir al menos una imagen de cierre ya que hubo cobros distintos a OpenPay",
        "warning"
      );
      return false;
    }

    // ✔ Resto de validaciones ya existentes
    const TPVamount = Calculationadvisor.cobrosTPV || 0;

    if (
      (TPVamount == 0 || (TPVamount > 0 && valueseted > 0)) &&
      authorization?.openclosingday?.user.id &&
      user?.id &&
      authorization.openclosingday.user.signature &&
      userSignature.signature &&
      comments
    ) {
      return true;
    }

    return false;
  };

  // const SaveLotClousure = () => {
  //   if (!Validations()) {
  //      showMessage("Ingrese los datos necesarios", "warning");
  //      return;
  //   }
  //     setisClosingday(true);
  //     try {
  //       const newPictureId = uuidv4();
  //       const filepath = !isProduction()
  //         ? "LotClousuresSandox/" +
  //         user?.id +
  //         "/LotClousure" +
  //         getCurrentDateTime() +
  //         newPictureId
  //         : "LotClousures/" +
  //         user?.id +
  //         "/LotClousure" +
  //         getCurrentDateTime() +
  //         newPictureId;
  //       firebasestorage
  //         .uploadFile(base64ToBlob(lotClousure), filepath)
  //         .then((urlpicture) => {
  //           SaveDayClousure(urlpicture);
  //         })
  //         .catch((e) => {
  //           e;
  //           setisClosingday(false);
  //           showMessage(
  //             "Hubo un problema al registrar el cierre del día, vuelva a intentarlo por favor",
  //             "error"
  //           );
  //         });
  //     } catch (error) {
  //       console.log(error);
  //     }
  // };

  const SaveLotClousure = async () => {
    if (!Validations()) {
      showMessage("Ingrese los datos necesarios", "warning");
      return;
    }
    if (Difference.status && comments.length < 20) {
      setDifferenceModalOpen(true);
      return;
    }
    setisClosingday(true);
    try {
      // 1) Subir todas las fotos en paralelo:
      const promises = imagesTaken.map((dataUrl) => {
        const picId = uuidv4();
        const path = !isProduction()
          ? `LotClousuresSandox/${
              user?.id
            }/LotClousure${getCurrentDateTime()}${picId}`
          : `LotClousures/${
              user?.id
            }/LotClousure${getCurrentDateTime()}${picId}`;
        return firebasestorage.uploadFile(base64ToBlob(dataUrl), path);
      });
      const urls = await Promise.all(promises);

      // 2) Concatenar sin separador extra (el regex frontal sabrá separarlas)
      const concatenated = urls.join("");
      //setLotClosureUrls(concatenated);

      // 3) Llamar a la función que arma el payload y hace el PUT/POST
      SaveDayClousure(concatenated);
    } catch (err) {
      setisClosingday(false);
      showMessage(
        "Hubo un problema al registrar el cierre del día, vuelva a intentarlo por favor",
        "error"
      );
    }
  };
  const SaveDayClousure = (urlpicture: any) => {
    const newCaluculationHistory = {
      ...PrevDayClousure?.calculationHistory,
      [getCurrentDateTime().replace("T", " ")]: {
        ...Calculationadvisor,
        details: {
          difference: Difference.status,
          feedback: comments,
          lotClosingTPV: urlpicture,
          fisicalVoucherComplete: vouchersComplete,
          cloudVoucherComplete: vouchersUploaded,
          amountEntered: Number(valueseted),
          idSupervisor: authorization.openclosingday.user.id,
        },
      },
    };

    const closingdayPayload = {
      id: PrevDayClousure?.id,
      idSupervisor: authorization.openclosingday.user.id,
      idAdviser: user?.id,
      signatureSupervisor: authorization.openclosingday.user.signature,
      signatureAdviser: userSignature.signature,
      amountEntered: Number(valueseted),
      fisicalVoucherComplete: vouchersComplete,
      cloudVoucherComplete: vouchersUploaded,
      lotClosingTPV: urlpicture,
      feedback: comments,
      calculationHistory: JSON.stringify(newCaluculationHistory),
      difference: Difference.status,
    };
    const onOkClosingResponse = (response: any) => {
      if (response.status == 200) {
        showMessage("Cierre de día completo", "success");
        setTimeout(() => {
          logout(() => {
            navigate("/Login");
          });
        }, 2000);
        return;
      }
      setisClosingday(false);
      showMessage(
        "Hubo un problema al registrar el cierre del día, vuelva a intentarlo por favor",
        "error"
      );
    };
    if (PrevDayClousure?.id)
      VisitaxPut(ClosingDay, closingdayPayload, onOkClosingResponse);
    else VisitaxPost(ClosingDay, closingdayPayload, onOkClosingResponse);
  };
  useEffect(() => {
    getCalcullationAdvisor();
  }, []);

  const handleSupervisorLogout = () => {
    if (authorization?.openclosingday) {
      authorization.openclosingday.user = null;
      authorization.openclosingday.signature = null;
    }

    setuserSignature({ signature: "", name: "" });
    setSupervisorLogoutDialogOpen(true);
  };

  console.log("userSignature ", userSignature);

  return (
    <Box sx={{ p: 2 }}>
      <Dialog
        open={differenceModalOpen}
        disableEscapeKeyDown
        onClose={(_, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        }}
      >
        <DialogTitle>Detalle de diferencia requerido</DialogTitle>
        <DialogContent>
          <Typography variant="h4" align="center" gutterBottom>
            Diferencia: {Difference ? Difference.diferenceamount : 0}
          </Typography>
          <Typography variant="subtitle1" align="center" gutterBottom>
            Monto ingresado: {valueseted}
          </Typography>
          <TextField
            label="Explica por qué hay diferencia"
            multiline
            rows={3}
            fullWidth
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            helperText={`${comments.length}/mínimo 20 caracteres`}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setDifferenceModalOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            // Sólo activo cuando cumple el largo mínimo
            disabled={comments.length < 20}
            onClick={() => {
              setDifferenceModalOpen(false);
              SaveLotClousure();
            }}
          >
            Confirmar cierre
          </Button>
        </DialogActions>
      </Dialog>
      {Calculationadvisor && !isClosingday ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CollectionsBreakdown
                onDifferenceChange={(difference: any) => {
                  setDifference(difference);
                }}
                onValueChange={(value: any) => {
                  setValueSetd(value);
                }}
                calculationAdvisor={Calculationadvisor}
                calculationAdvisorTitles={CalculationadvisorTitles}
                amountsHistory={PrevDayClousure?.calculationHistory}
                cancelDigitNumber={false}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <LotClosureTaker
                initialImages={imagesTaken}
                onImagesChange={(arr) => setImagesTaken(arr)}
              />
            </Grid>

            {/* Historial de imágenes */}
            {PrevDayClousure?.calculationHistory && (
              <Grid item xs={12}>
                <ImagesHistoryAccordion
                  history={PrevDayClousure?.calculationHistory}
                />
              </Grid>
            )}
          </Grid>
          <Box sx={{ margin: 5 }}>
            <TextField
              label="Comentarios"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              sx={{ mb: 2 }}
            />

            {PrevDayClousure?.calculationHistory && (
              <CommentsHistoryAccordion
                history={PrevDayClousure?.calculationHistory}
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={vouchersComplete}
                  onChange={(e) => setVouchersComplete(e.target.checked)}
                />
              }
              label="Se entregan vouchers completos"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={vouchersUploaded}
                  onChange={(e) => setVouchersUploaded(e.target.checked)}
                />
              }
              label="Se suben todos los vouchers"
            />

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                {authorization?.openclosingday?.user?.signature && (
                  <SignatureViewer
                    signature={authorization.openclosingday.user.signature}
                    name={authorization.openclosingday.user.fullname}
                    title="Supervisor"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <SignatureViewer
                  signature={userSignature.signature}
                  name={userSignature.name}
                  title="Asesor"
                />
                {!userSignature.signature && (
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleDayClosure}
                    sx={{ mt: 1 }}
                  >
                    Autorización de asesor
                  </Button>
                )}
              </Grid>
            </Grid>

            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 3 }}
              onClick={() => SaveLotClousure()}
            >
              Cierre de Día
            </Button>
          </Box>

          <AuthorizationComponent
            title="Autorización Asesor"
            description="Al autorizar aceptas que los datos del cierre son correctos"
            userAuthorized={{
              fullname: userSignature.name,
              id: user?.id,
              signature: userSignature.signature,
            }}
            onAutorizationDone={handleAuthorize}
            open={openAuth}
            onClose={() => setOpenAuth(false)}
          />
        </>
      ) : (
        <>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={80}
            sx={{ mb: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={40}
            sx={{ mb: 1 }}
          />
          <Skeleton variant="rectangular" width="100%" height={40} />
        </>
      )}

      <MessageDialog
        onClose={() => setDialogData((prev) => ({ ...prev, open: false }))}
        {...dialogData}
      />
      <MessageDialog
        open={supervisorLogoutDialogOpen}
        title="Sesión del supervisor cerrada"
        message="La sesión del supervisor ha sido cerrada correctamente."
        type="success"
        onClose={() => {
          setSupervisorLogoutDialogOpen(false);
          navigate("/AdministrationPanel/AdvisorPanel");
        }}
      />

      {authorization?.openclosingday?.user && (
        <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
          <Button variant="outlined" onClick={handleSupervisorLogout}>
            Cerrar sesión del supervisor
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default DayClousure;
